module.exports = __webpack_public_path__ + "img/5.a16caee3.png";